(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('RacePositionsController', RacePositionsController);

    RacePositionsController.$inject = ['RacePositions'];

    function RacePositionsController(RacePositions) {

        var vm = this;

        vm.racePositions = [];

        loadAll();

        function loadAll() {
            RacePositions.query(function(result) {
                vm.racePositions = result;
                vm.searchQuery = null;
            });
        }
    }
})();
